webpackJsonp([35783957827783],{

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(49);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _gatsbyImage = __webpack_require__(31);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(50);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Will create a component that will list down all blog posts
	// in cards which gets passed to it.
	var BlogCard = function BlogCard(_ref) {
		var excerpt = _ref.excerpt,
		    featuredImage = _ref.featuredImage,
		    tags = _ref.tags,
		    title = _ref.title,
		    slug = _ref.slug,
		    date = _ref.date;
		return _react2.default.createElement(
			'div',
			{ className: 'blog-card' },
			_react2.default.createElement(
				'header',
				{ className: 'blog-card__header' },
				_react2.default.createElement(
					'h2',
					{ className: 'title is-4' },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: slug },
						title
					)
				),
				_react2.default.createElement(
					'p',
					{ className: 'subtitle is-6' },
					'on ' + date + ' \u2022 under',
					tags.map(function (tag) {
						return _react2.default.createElement(
							_gatsbyLink2.default,
							{
								to: '/tags/' + (0, _lodash2.default)(tag) + '/',
								className: 'tag',
								key: tag
							},
							tag
						);
					})
				)
			),
			featuredImage && featuredImage.childImageSharp && featuredImage.childImageSharp.sizes ? _react2.default.createElement(
				'div',
				{ className: 'blog-card__featured-image' },
				_react2.default.createElement(
					'figure',
					{ className: 'image is-fullwidth' },
					_react2.default.createElement(
						_gatsbyLink2.default,
						{ to: slug },
						_react2.default.createElement(_gatsbyImage2.default, {
							sizes: featuredImage.childImageSharp.sizes,
							alt: title
						})
					)
				)
			) : null,
			_react2.default.createElement(
				'div',
				{ className: 'blog-card__content' },
				_react2.default.createElement(
					'div',
					{ className: 'content has-text-justified' },
					_react2.default.createElement(
						'p',
						null,
						excerpt
					)
				)
			),
			_react2.default.createElement(
				'footer',
				{ className: 'blog-card__footer' },
				_react2.default.createElement(
					_gatsbyLink2.default,
					{ to: slug, className: 'button is-outlined is-rounded' },
					'READ MORE'
				)
			)
		);
	};
	
	BlogCard.propTypes = {
		excerpt: _propTypes2.default.string.isRequired,
		featuredImage: _propTypes2.default.shape({
			sizes: _propTypes2.default.string,
			srcSet: _propTypes2.default.string
		}),
		title: _propTypes2.default.string.isRequired,
		slug: _propTypes2.default.string.isRequired,
		tags: _propTypes2.default.arrayOf(_propTypes2.default.string),
		date: _propTypes2.default.string.isRequired
	};
	BlogCard.defaultProps = {
		featuredImage: null,
		tags: []
	};
	
	exports.default = BlogCard;
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyImage = __webpack_require__(31);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(109);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProjectList = function ProjectList(_ref) {
		var title = _ref.title,
		    subtitle = _ref.subtitle,
		    featuredImage = _ref.featuredImage,
		    link = _ref.link,
		    html = _ref.html;
		return _react2.default.createElement(
			'div',
			{ className: 'project-list' },
			_react2.default.createElement(
				'div',
				{ className: 'project-list__image' },
				_react2.default.createElement(
					'a',
					{ href: link, target: '_blank', rel: 'noopener noreferrer' },
					_react2.default.createElement(_gatsbyImage2.default, { sizes: featuredImage, alt: title })
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'project-list__content' },
				_react2.default.createElement(
					'div',
					{ className: 'project-list__titles' },
					_react2.default.createElement(
						'h2',
						{ className: 'title is-4' },
						title
					),
					_react2.default.createElement(
						'h3',
						{ className: 'subtitle is-6' },
						subtitle
					)
				),
				typeof html === 'string' ? _react2.default.createElement('div', {
					className: 'content project-list__text has-text-justified',
					dangerouslySetInnerHTML: { __html: html }
				}) : _react2.default.createElement(
					'div',
					{ className: 'content project-list__text has-text-justified' },
					html
				),
				_react2.default.createElement(
					'div',
					{ className: 'project-list__link' },
					_react2.default.createElement(
						'a',
						{
							href: link,
							target: '_blank',
							rel: 'noopener noreferrer',
							className: 'button is-medium is-outlined is-rounded'
						},
						'VISIT'
					)
				)
			)
		);
	};
	
	ProjectList.propTypes = {
		title: _propTypes2.default.string.isRequired,
		subtitle: _propTypes2.default.string.isRequired,
		featuredImage: _propTypes2.default.shape({
			sizes: _propTypes2.default.string.isRequired,
			srcSet: _propTypes2.default.string.isRequired
		}).isRequired,
		link: _propTypes2.default.string.isRequired,
		html: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired
	};
	
	exports.default = ProjectList;
	module.exports = exports['default'];

/***/ }),

/***/ 109:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _BlogCard = __webpack_require__(40);
	
	var _BlogCard2 = _interopRequireDefault(_BlogCard);
	
	var _ProjectList = __webpack_require__(70);
	
	var _ProjectList2 = _interopRequireDefault(_ProjectList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
		_inherits(IndexPage, _React$Component);
	
		function IndexPage() {
			_classCallCheck(this, IndexPage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		IndexPage.prototype.render = function render() {
			var _props$data = this.props.data,
			    _props$data$posts = _props$data.posts,
			    edges = _props$data$posts.edges,
			    totalPosts = _props$data$posts.totalCount,
			    _props$data$projects = _props$data.projects,
			    projectEdges = _props$data$projects.edges,
			    totalProjects = _props$data$projects.totalCount;
	
			return _react2.default.createElement(
				'section',
				{ className: 'section' },
				_react2.default.createElement(
					'div',
					{ className: 'container' },
					_react2.default.createElement(
						'h2',
						{ className: 'subtitle is-3 home-blog-title' },
						'Latest Projects'
					),
					_react2.default.createElement(
						'div',
						{ className: 'home-page-projects' },
						projectEdges.map(function (project) {
							var _project$node = project.node,
							    html = _project$node.html,
							    id = _project$node.id,
							    _project$node$frontma = _project$node.frontmatter,
							    featuredImage = _project$node$frontma.featured_image.childImageSharp.sizes,
							    title = _project$node$frontma.title,
							    subtitle = _project$node$frontma.subtitle,
							    link = _project$node$frontma.link;
	
							return _react2.default.createElement(_ProjectList2.default, _extends({
								key: id
							}, {
								title: title,
								html: html,
								link: link,
								featuredImage: featuredImage,
								subtitle: subtitle
							}));
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'home-browse' },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								className: 'button is-large is-link is-outlined is-rounded',
								to: '/projects/'
							},
							'EXPLORE ALL ' + totalProjects + ' PROJECTS'
						)
					),
					_react2.default.createElement(
						'h2',
						{ className: 'subtitle is-3 home-blog-title' },
						'Latest From Blog'
					),
					_react2.default.createElement(
						'div',
						{ className: 'columns is-desktop is-multiline' },
						edges.map(function (item) {
							var _item$node = item.node,
							    excerpt = _item$node.excerpt,
							    slug = _item$node.fields.slug,
							    _item$node$frontmatte = _item$node.frontmatter,
							    date = _item$node$frontmatte.date,
							    featuredImage = _item$node$frontmatte.featured_image,
							    tags = _item$node$frontmatte.tags,
							    title = _item$node$frontmatte.title,
							    id = _item$node.id;
	
							var cardProps = {
								excerpt: excerpt,
								date: date,
								featuredImage: featuredImage,
								tags: tags,
								title: title,
								slug: slug
							};
							return _react2.default.createElement(
								'div',
								{ className: 'column is-full', key: id },
								_react2.default.createElement(_BlogCard2.default, cardProps)
							);
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'home-browse' },
						_react2.default.createElement(
							_gatsbyLink2.default,
							{
								className: 'button is-large is-link is-outlined is-rounded',
								to: '/blog/'
							},
							'BROWSE ALL ' + totalPosts + ' ENTRIES'
						)
					)
				)
			);
		};
	
		return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	
	
	IndexPage.propTypes = {
		data: _propTypes2.default.shape({
			posts: _propTypes2.default.shape({
				edges: _propTypes2.default.array
			})
		}).isRequired
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9c6583c2271638200d17.js